export default __webpack_public_path__ + "static/media/ic_whatsapp.c417e76f.svg";